<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.75 2.44458C8.75 2.03037 9.08579 1.69458 9.5 1.69458H11.2778C12.6742 1.69458 13.8056 2.82592 13.8056 4.22236V6.00014C13.8056 6.41435 13.4698 6.75014 13.0556 6.75014C12.6413 6.75014 12.3056 6.41435 12.3056 6.00014V4.22236C12.3056 3.65435 11.8458 3.19458 11.2778 3.19458H9.5C9.08579 3.19458 8.75 2.85879 8.75 2.44458Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.94446 9.25012C2.35867 9.25012 2.69446 9.58591 2.69446 10.0001V11.7779C2.69446 12.3459 3.15423 12.8057 3.72224 12.8057H5.50001C5.91423 12.8057 6.25001 13.1415 6.25001 13.5557C6.25001 13.9699 5.91423 14.3057 5.50001 14.3057H3.72224C2.3258 14.3057 1.19446 13.1743 1.19446 11.7779V10.0001C1.19446 9.58591 1.53024 9.25012 1.94446 9.25012Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.72224 3.19446C3.15423 3.19446 2.69446 3.65423 2.69446 4.22224V6.00001C2.69446 6.41423 2.35867 6.75001 1.94446 6.75001C1.53024 6.75001 1.19446 6.41423 1.19446 6.00001V4.22224C1.19446 2.8258 2.3258 1.69446 3.72224 1.69446H5.50001C5.91423 1.69446 6.25001 2.03024 6.25001 2.44446C6.25001 2.85867 5.91423 3.19446 5.50001 3.19446H3.72224Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.0556 9.25012C13.4698 9.25012 13.8056 9.58591 13.8056 10.0001V11.7779C13.8056 13.1743 12.6742 14.3057 11.2778 14.3057H9.5C9.08579 14.3057 8.75 13.9699 8.75 13.5557C8.75 13.1415 9.08579 12.8057 9.5 12.8057H11.2778C11.8458 12.8057 12.3056 12.3459 12.3056 11.7779V10.0001C12.3056 9.58591 12.6413 9.25012 13.0556 9.25012Z"
    fill="currentColor"
  />
</svg>
